// =====================================================
// SCHEMAS: USER
// Description: Schémas de validation Zod pour les utilisateurs
// =====================================================

import { z } from 'zod';

export const createUserSchema = z.object({
  email: z.string().email('Email invalide'),
  full_name: z.string().min(1, 'Le nom est requis').max(100, 'Le nom est trop long'),
  password: z.string().min(8, 'Le mot de passe doit contenir au moins 8 caractères'),
  role: z.enum(['admin', 'user']),
});

export type CreateUserInput = z.infer<typeof createUserSchema>;

export const changePasswordSchema = z.object({
  newPassword: z.string().min(8, 'Le mot de passe doit contenir au moins 8 caractères'),
});

export type ChangePasswordInput = z.infer<typeof changePasswordSchema>;

export const updateUserRoleSchema = z.object({
  role: z.enum(['admin', 'user']),
});

export type UpdateUserRoleInput = z.infer<typeof updateUserRoleSchema>;

export const updateUserFullNameSchema = z.object({
  full_name: z.string().min(1, 'Le nom est requis').max(100, 'Le nom est trop long'),
});

export type UpdateUserFullNameInput = z.infer<typeof updateUserFullNameSchema>;
